function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var BINARY_KEYS = new Set(['file', 'rom', 'zip', 'wasm', 'binary']);
var ListingInspectOverlay = /*#__PURE__*/function () {
  function ListingInspectOverlay(app, mod) {
    _classCallCheck(this, ListingInspectOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.overlay["class"] = 'saito-overlay listing-inspect-shell';
    this.tx = null;
  }
  return _createClass(ListingInspectOverlay, [{
    key: "escapeHtml",
    value: function escapeHtml() {
      var _this$app;
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.browser) !== null && _this$app !== void 0 && _this$app.escapeHTML) {
        return this.app.browser.escapeHTML(String(value));
      }
      return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  }, {
    key: "classifyString",
    value: function classifyString(key, value) {
      var k = String(key || '').toLowerCase();
      if (k === 'image' || value.startsWith('data:image/')) {
        return 'image';
      }
      if (BINARY_KEYS.has(k)) {
        return 'binary';
      }
      if (value.startsWith('data:') && !value.startsWith('data:text/')) {
        return 'binary';
      }
      if (value.length > 8192 && !/\s/.test(value.slice(0, 400)) && /^[A-Za-z0-9+/=]+$/.test(value.slice(0, 400))) {
        return 'binary';
      }
      if (value.includes('\n') || value.length > 160) {
        return 'text';
      }
      return 'scalar';
    }
  }, {
    key: "renderValue",
    value: function renderValue(key, value) {
      var _this = this;
      if (typeof value === 'bigint') {
        value = value.toString();
      }
      if (value == null) {
        return "<span class=\"listing-inspect-empty\">null</span>";
      }
      if (typeof value === 'boolean' || typeof value === 'number') {
        return "<span class=\"listing-inspect-scalar\">".concat(this.escapeHtml(String(value)), "</span>");
      }
      if (typeof value === 'string') {
        var kind = this.classifyString(key, value);
        if (kind === 'image') {
          var _this$app2, _this$app2$isSafeMedi;
          if ((_this$app2 = this.app) !== null && _this$app2 !== void 0 && (_this$app2 = _this$app2.browser) !== null && _this$app2 !== void 0 && (_this$app2$isSafeMedi = _this$app2.isSafeMediaUrl) !== null && _this$app2$isSafeMedi !== void 0 && _this$app2$isSafeMedi.call(_this$app2, value)) {
            return "<figure class=\"listing-inspect-media\"><img src=\"".concat(this.escapeHtml(value), "\" alt=\"").concat(this.escapeHtml(key || 'image'), "\"></figure>");
          }
          return "<span class=\"listing-inspect-binary\">BINARY</span><span class=\"listing-inspect-bytes\">".concat(value.length, " bytes</span>");
        }
        if (kind === 'binary') {
          return "<span class=\"listing-inspect-binary\">BINARY</span><span class=\"listing-inspect-bytes\">".concat(value.length, " bytes</span>");
        }
        if (kind === 'text') {
          return "<pre class=\"listing-inspect-text\">".concat(this.escapeHtml(value), "</pre>");
        }
        return "<span class=\"listing-inspect-scalar\">".concat(this.escapeHtml(value), "</span>");
      }
      if (Array.isArray(value)) {
        if (!value.length) {
          return "<span class=\"listing-inspect-empty\">[]</span>";
        }
        return "<ol class=\"listing-inspect-list\">".concat(value.map(function (item, i) {
          return "<li>".concat(_this.renderValue(String(i), item), "</li>");
        }).join(''), "</ol>");
      }
      if (_typeof(value) === 'object') {
        return this.renderObject(value);
      }
      return "<span class=\"listing-inspect-scalar\">".concat(this.escapeHtml(String(value)), "</span>");
    }
  }, {
    key: "renderObject",
    value: function renderObject(obj) {
      var _this2 = this;
      var entries = Object.entries(obj || {});
      if (!entries.length) {
        return "<span class=\"listing-inspect-empty\">{}</span>";
      }
      return "<dl class=\"listing-inspect-fields\">".concat(entries.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          nested = _ref2[1];
        var nested_object = nested && _typeof(nested) === 'object' && !Array.isArray(nested) && typeof nested !== 'bigint';
        return "\n        <div class=\"listing-inspect-row".concat(nested_object ? ' is-block' : '', "\">\n          <dt>").concat(_this2.escapeHtml(key), "</dt>\n          <dd>").concat(_this2.renderValue(key, nested), "</dd>\n        </div>");
      }).join(''), "</dl>");
    }
  }, {
    key: "downloadTransaction",
    value: function downloadTransaction() {
      var tx = this.tx;
      if (!tx || typeof tx.serialize_to_web !== 'function') {
        if (typeof siteMessage === 'function') {
          siteMessage('Transaction is not available to download.', 3000);
        }
        return;
      }
      var json = tx.serialize_to_web(this.app);
      var sig = String(tx.signature || 'listing').replace(/[^\w.-]+/g, '_').slice(0, 16);
      var url = URL.createObjectURL(new Blob([json], {
        type: 'application/json'
      }));
      var link = document.createElement('a');
      link.href = url;
      link.download = "listing-tx-".concat(sig, ".saito");
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }, {
    key: "open",
    value: function open(summary) {
      var _root$querySelector,
        _this3 = this;
      if (!summary) {
        return;
      }
      this.tx = null;
      this.overlay.show("\n      <article class=\"listing-inspect saito-overlay-panel retain-surface\">\n        <header>\n          <h2 class=\"listing-inspect-title\">Inspect listing</h2>\n          <button type=\"button\" class=\"saito-button-secondary\" data-inspect-download disabled>Download transaction</button>\n        </header>\n        <p class=\"listing-inspect-status\" data-inspect-status>Loading transaction\u2026</p>\n        <div class=\"listing-inspect-body\" data-inspect-body></div>\n      </article>\n    ");
      var root = document.querySelector('.listing-inspect');
      root === null || root === void 0 || (_root$querySelector = root.querySelector('[data-inspect-download]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function () {
        _this3.downloadTransaction();
      });
      var finish = function finish(tx) {
        var status = root === null || root === void 0 ? void 0 : root.querySelector('[data-inspect-status]');
        var host = root === null || root === void 0 ? void 0 : root.querySelector('[data-inspect-body]');
        var download = root === null || root === void 0 ? void 0 : root.querySelector('[data-inspect-download]');
        if (!host) {
          return;
        }
        _this3.tx = tx || null;
        if (_this3.tx && download) {
          download.disabled = false;
        }
        var txmsg = (typeof (tx === null || tx === void 0 ? void 0 : tx.returnMessage) === 'function' ? tx.returnMessage() : tx === null || tx === void 0 ? void 0 : tx.msg) || null;
        if (!txmsg) {
          if (status) {
            status.hidden = false;
            status.textContent = 'Listing transaction message is unavailable.';
          }
          return;
        }
        if (status) {
          status.hidden = true;
        }
        try {
          host.innerHTML = _this3.renderObject(txmsg);
        } catch (err) {
          host.textContent = String((err === null || err === void 0 ? void 0 : err.message) || err);
        }
      };
      if (summary.listing_tx) {
        finish(summary.listing_tx);
        return;
      }
      if (typeof summary.ensureListingTransaction !== 'function') {
        finish(null);
        return;
      }
      summary.ensureListingTransaction().then(function (loaded) {
        return finish((loaded === null || loaded === void 0 ? void 0 : loaded.listing_tx) || summary.listing_tx || null);
      })["catch"](function (err) {
        var status = document.querySelector('.listing-inspect [data-inspect-status]');
        if (status) {
          status.hidden = false;
          status.textContent = (err === null || err === void 0 ? void 0 : err.message) || 'Unable to load listing transaction.';
        }
        if (typeof siteMessage === 'function') {
          siteMessage((err === null || err === void 0 ? void 0 : err.message) || 'Unable to load listing transaction.', 4000);
        }
      });
    }
  }]);
}();
module.exports = ListingInspectOverlay;